import React from 'react';

type StatusType = 'active' | 'inactive' | 'pending' | 'blocked' | 'approved' | 'draft' | 'failed';

interface StatusBadgeProps {
  status: string;
  className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className = '' }) => {
  const normalizedStatus = status.toLowerCase() as StatusType;
  
  const getStatusClasses = () => {
    switch (normalizedStatus) {
      case 'active':
      case 'approved':
        return 'bg-green-100 text-green-700';
      case 'inactive':
      case 'blocked':
        return 'bg-red-100 text-red-700';
      case 'pending':
        return 'bg-yellow-100 text-yellow-700';
      case 'draft':
        return 'bg-gray-100 text-gray-700';
      case 'failed':
        return 'bg-red-100 text-red-700';
      default:
        return 'bg-gray-100 text-gray-700';
    }
  };
  
  return (
    <span
      className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${getStatusClasses()} ${className}`}
    >
      {status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()}
    </span>
  );
};

export default StatusBadge;